<template>
  <div class="dcf-grid dcf-w-100%">
    <div class="dcf-col dcf-col-50%-start@md">
      <div class="dcf-form dcf-d-flex">
        <div class="dcf-form-group dcf-mr-5">
          <label for="layer">Layer</label>
          <input id="layer" type="range" v-model="activeLayer" min="0" :max="layers.length -1" />
        </div>
        <div class="dcf-form-group">
          <label for="photoIllustration">Photo/Illustration</label>
          <input id="photoIllustration" type="range" v-model="opacity" min="0" max="1" step=".1"  />
      </div>
    </div>


      
      <div>
        <svg width="370" height="250">
          <image :xlink:href="'data:image/jpg;base64,' + layers[activeLayer].photo" /> 
          <image :xlink:href="'data:image/jpg;base64,' + layers[activeLayer].illustration" :opacity="opacity" /> 
          <polygon class="bone_polygon" v-for="bone in layers[activeLayer].bones" v-on:click="setActiveEntity(bone.bone_id, 'bone')" :points="bone.coords"  fill="transparent" />
          <polygon class="muscle_polygon" v-for="muscle in layers[activeLayer].muscles" v-on:click="setActiveEntity(muscle.muscle_id, 'muscle')" :points="muscle.coords" fill="transparent" />
        </svg>
        <p>{{ layers[activeLayer].name }}</p>
      </div>
    </div>

    <div class="dcf-col dcf-col-50%-end@md">
      <div>
        <bone v-if="activeEntity.type == 'bone'" :bone="activeEntityOutput"></bone>
        <muscle v-if="activeEntity.type == 'muscle'" :muscle="activeEntityOutput" :profiles="profiles"></muscle>
      </div>
    </div>
      
  </div>
</template>

<style>
  .bone_polygon {
    opacity: .1;
    stroke: black;
    stroke-width: 4px;
    cursor: pointer;
  }
  .muscle_polygon {
    opacity: .1;
    stroke: black;
    stroke-width: 4px;
    cursor: pointer;
  }
  .muscle_polygon:hover,
  .bone_polygon:hover {
    opacity: 1;
  }
</style>

<script>
  // import template from 'lodash/template';
  import bone from './bone.vue';
  import muscle from './muscle.vue';

  const keyBy = (array, key) => (array || []).reduce((r, x) => ({ ...r, [key ? x[key] : x]: x }), {});

  export default {
    components: { bone, muscle },
    data: function(){
      return {
        crosssection: null,
        muscles: {},
        musclesLoaded: false,
        bones: {},
        activeLayer: 0,
        opacity: .5,
        activeEntity: { id: null, type: null },
        loading: false,
        profiles: []
      }
    },
    computed: {
      activeEntityOutput: function(){
        switch(this.activeEntity.type){
          case 'bone':
            return this.bones[ this.activeEntity.id ];
            break;
          case 'muscle':
            return this.muscles[ this.activeEntity.id ];
            break;
          default:
            return false;
        }
      },
      layers: function(){
        var $this = this;
        return Object.keys( $this.crosssection.layers ).map( function(k) { return $this.crosssection.layers[k] } );
      }
    },
    methods: {
      setActiveEntity: function(id, type){
        this.activeEntity = { id: id, type: type };
      },
      musclesFetched: function(data){
        this.muscles = keyBy(data, 'id');
        // this.muscles = data.reduce(function(r,x){ ({ ...r, [x.id]: x })}, {}); 
        this.musclesLoaded = true;
      }
    },
    created: function(){
      this.crosssection = window.crosssection;
      this.fetchData('/muscles.json', this.musclesFetched, this.handleErrors);
      // this.muscles = window.muscles;
      this.muscle_ids = window.muscle_ids;
      this.bones = window.bones;
      this.profiles = window.profiles;
    }
  }
</script>
